import { createDownloadSlice } from '@repo/core'
import { ConvenienceTestDraftPdfParams } from '@repo/user-types'

export const {
  actions: convenienceTestsDraftPdfDownloadActions,
  reducer: convenienceTestsDraftPdfDownloadReducer,
} = createDownloadSlice<ConvenienceTestDraftPdfParams>('@users/convenienceTestsDraftPdfDownload')
